import { Select, Space, Tooltip, Typography, message } from 'antd'
import { ApartmentOutlined } from '@ant-design/icons'
import { useQuery, useQueryClient } from '@tanstack/react-query'
import { orgsAPI } from '@/api/orgs'
import { useImpersonationStore } from '@/store/impersonation'

const { Text } = Typography
const ORG_SCOPED_QUERY_KEYS = new Set([
  'filials',
  'services',
  'departments',
  'plan-indicators',
  'otd-filials-periods',
  'otd-filials-period-check',
  'otd-filials',
  'current-structure',
  'bed-fund-periods',
  'bed-fund-period-check',
  'bed-fund',
  'recviz-periods',
  'recviz-data',
  'recviz-summary',
  'recviz-calculation-detail',
  'recviz-threshold-settings',
  'file-batches',
])

export function OrgSwitcher() {
  const { impersonatedOrgId, startImpersonation } = useImpersonationStore()
  const queryClient = useQueryClient()

  const { data: orgs = [], isLoading } = useQuery({
    queryKey: ['orgs'],
    queryFn: orgsAPI.list,
    staleTime: 5 * 60 * 1000,
  })

  const handleChange = async (orgId: string) => {
    const org = orgs.find((o) => o.id === orgId)
    if (!org) return
    try {
      await startImpersonation(org.id, org.name)
      await queryClient.invalidateQueries({
        predicate: (query) => ORG_SCOPED_QUERY_KEYS.has(String(query.queryKey[0])),
      })
      message.success(`Рабочий контекст ЛПУ: ${org.name}`)
    } catch {
      message.error('Не удалось переключить организацию')
    }
  }

  const options = orgs.map((org) => ({
    value: org.id,
    label: `${org.code} · ${org.short_name || org.name}`,
    title: org.name,
  }))

  return (
    <Tooltip title="Рабочее ЛПУ для справочников, структуры, коечного фонда, реквизитов и загрузок">
      <Space>
        <ApartmentOutlined style={{ color: '#faad14' }} />
        <Text type="warning" style={{ fontSize: 12 }}>
          Контекст ЛПУ:
        </Text>
        <Select
          placeholder="Выбрать ЛПУ"
          value={impersonatedOrgId ?? undefined}
          onChange={handleChange}
          options={options}
          loading={isLoading}
          allowClear={false}
          style={{ minWidth: 220 }}
          size="small"
          showSearch
          optionFilterProp="label"
        />
      </Space>
    </Tooltip>
  )
}
